export const uk = {
    full: 'Полный',
    partial: 'Частичный'
};
